import { runIfFn } from "@chakra-ui/utils";
/* -----------------------------------------------------------------------------
 * Style Configuration definition for components
 * -----------------------------------------------------------------------------*/

export { runIfFn };
export function mode(light, dark) {
  return props => props.colorMode === "dark" ? dark : light;
}
export function orient(options) {
  var {
    orientation,
    vertical,
    horizontal
  } = options;
  if (!orientation) return {};
  return orientation === "vertical" ? vertical : horizontal;
}
//# sourceMappingURL=component.js.map